module.exports = __webpack_public_path__ + "img/page-07.241bd563.jpg";